module.exports = __webpack_public_path__ + "img/nautical-chart.9ea97193.jpg";